import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class CategoryMaintenanceService {

  constructor(
    private http: HttpService,
  ) { }

  getList(data?: any) {
    return this.http.post(Path.CATEGORY.GET_LIST, data);
  }

  getDetail(params?: any) {
    return this.http.get(Path.CATEGORY.GET_DETAIL, params);
  }
    
  insert(data?: any) {
    return this.http.post(Path.CATEGORY.INSERT, data);
  }

  genericMaintenanceDownload(data?: any) {
    return this.http.post(Path.DOWNLOAD.DOWNLOAD_CATEGORY_MAINTENACE, data);
  }
}